export default __webpack_public_path__ + "static/assets/SL-triangle-light.9f082e21.png";